import { Suspense, lazy } from "react";

import { Layout } from "../../features/layout";

const Content = lazy(() => import("./LegalContent"));

export function LegalPage() {
  return (
    <Layout>
      <Suspense fallback={null}>
        <Content />
      </Suspense>
    </Layout>
  );
}
